export const TOKEN_KEY = 'BlogsConsumerToken';
export const USER_DATA_KEY = 'BlogsConsumerUser';

// Others...
export const FallbackImage = '/images/icons/no-image-placeholder.jpg';

// Modal
export const MODAL_REDUCER = "MODAL_REDUCER";